import { forwardRef } from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  () => ({
    root: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: 300,
    },
  }),
  { classNamePrefix: 'ItemLabel' }
);

export default forwardRef((props, ref) => {
  const classes = useStyles();

  return <Typography component="span" className={classes.root} {...props} ref={ref} />;
});
